import axiosInstance from "./axiosInstance";

export const fetchRoles = () => axiosInstance.get("/superadmin/roles");
export const createRole = (data) => axiosInstance.post("/superadmin/roles", data);
export const updateRole = (id, data) => axiosInstance.put(`/superadmin/roles/${id}`, data);
export const deleteRole = (id) => axiosInstance.delete(`/superadmin/roles/${id}`);